export default "//qa-static.lanacion.com.ar/v2/ingresar-nuevo/images/error-gral.png";